import React from 'react';
import { useSlate } from 'slate-react';
import ToolbarButton from '@plone/volto-slate/editor/ui/ToolbarButton';
import icon from '@plone/volto/icons/align-left.svg';

import { isStyleActive, toggleStyle } from '../../../utils/slate';

const STYLE = 'text-left';

const AlignLeftButton = () => {
  const editor = useSlate();

  return (
    <ToolbarButton
      icon={icon}
      title="Left Align"
      active={isStyleActive(editor, STYLE)}
      onMouseDown={(e) => {
        e.preventDefault();
        toggleStyle(editor, STYLE);
      }}
    />
  );
};

export default AlignLeftButton;